import { http } from './http';
import { ROUTES } from './config';
import type { NewsletterListResponse } from '../types/domain';

/**
 * TenantService/NewsletterController client. Subscribe/unsubscribe are anonymous (storefront
 * footer signup + one-click unsubscribe link in email footers); list is manager+ (admin
 * subscriber list).
 */
export const newsletterApi = {
  subscribe(email: string, source?: string): Promise<{ status: string }> {
    return http.post(ROUTES.newsletter.subscribe, { email, source }, { anonymous: true });
  },

  unsubscribe(id: string): Promise<{ status: string }> {
    return http.post(ROUTES.newsletter.unsubscribe(id), undefined, { anonymous: true });
  },

  /** Manager+ only. */
  list(activeOnly = true): Promise<NewsletterListResponse> {
    return http.get(ROUTES.newsletter.list(activeOnly));
  },
};
